export default __webpack_public_path__ + "static/media/4.ce432f39.jpg";